export default __webpack_public_path__ + "static/media/HUSD-USDT.755d0ea9.svg";